    <div class="dynamic-field form-button" [formGroup]="group">
    <button mat-raised-button id="{{config.id}}" (click)="eventcallbackMethod($event)" [disabled]="config.disabled" type="submit" [ngClass]="config.class">
        {{ config.label }}
    </button>
    </div>

    <!-- [ngClass]="config.class" (click)="config.function($event)" After angular 9 update this method not working--> 